import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

import { ResourceListItem } from 'src/types/ResourceListItem';

import BookSvg from 'public/icons/Book.svg';
import ClockSvg from 'public/icons/clock.svg';
import MarkerSvg from 'public/icons/Marker.svg';
import PeopleSvg from 'public/icons/People.svg';
import PersonTickSvg from 'public/icons/PersonTick.svg';
import PriceTagSvg from 'public/icons/PriceTag.svg';

import styles from './_CardAttributeList.module.css';

export type CardAttributeListProps = {
	item: ResourceListItem;
	cpdHoursText?: Field<string>;
	accessTypeText?: string;
	iconColour?: string;
};

export default function CardAttributeList(props: CardAttributeListProps): JSX.Element {

	const listComponent = (icon: JSX.Element, item?: string) => {
		return (
			<li className={styles.metaItem}>
				<span>{icon}</span>
				<span className={styles.metaText}>{item}</span>
			</li>
		);
	};

	const typesOfResources =
		props.item.TypesOfResources && props.item.TypesOfResources.length > 0 ? props.item.TypesOfResources.join(', ') : undefined;

	const learningType = props.item.LearningType;

	let cpdHoursString = props.item.CpdHours;
	if (props.item.CpdHours) {
		const timeRegex = /([0-9]?[0-9]):([0-9][0-9]):([0-9][0-9])/;
		const matches = props.item.CpdHours.match(timeRegex);
		if (matches && matches.length > 3) {
			const hours = parseInt(matches[1]);
			const minutes = parseInt(matches[2]);

			const totalHours = hours + minutes / 60;

			cpdHoursString = (minutes > 0 ? totalHours.toFixed(1) : totalHours.toString()) + ' ' + props.cpdHoursText?.value;
		}
	}

	return (
		<ul className={styles.metaList}>
			{(typesOfResources || learningType) && listComponent(<BookSvg className={`${styles.metaIcon} ${styles.pinkDark}`} />, typesOfResources || learningType)}

			{props.item.AccessTypes && props.accessTypeText !== '' && listComponent(<PersonTickSvg className={`${styles.metaIcon} ${props.iconColour ? styles[props.iconColour] : styles.pinkDark}`} />, props.accessTypeText)}

			{props.item.LearningFormats && listComponent(<PeopleSvg className={`${styles.metaIcon} ${styles.pinkDark}`} />, props.item.LearningFormats.join(', '))}

			{props.item.Location && listComponent(<MarkerSvg className={`${styles.metaIcon} ${styles.pinkDark}`} />, props.item.Location)}

			{props.item.Cost && listComponent(<PriceTagSvg className={`${styles.metaIcon} ${styles.pinkDark}`} />, props.item.Cost)}

			{props.item.CpdHours && listComponent(<ClockSvg className={`${styles.metaIcon} ${styles.pinkDark}`} />, cpdHoursString)}
		</ul>
	);
}